<script setup lang="ts">

</script>

<template>
    <div class="TopNote">
        <slot />
    </div>
</template>


<style lang="scss" scoped>
.TopNote {
    z-index: 100;
    font-style: italic;
    text-align: left;
    margin-bottom: 20px;
}
</style>
